import { Field, Float, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class ChangePlanSummaryDto {
  @Field(t => Float)
  subtotal!: number

  @Field(t => Float)
  tax!: number

  @Field(t => Float)
  total!: number

  @Field(t => Float)
  credit!: number

  /** Referral credit this change will consume, in dollars. Zero when the author has none. */
  @Field(t => Float)
  referralCredit!: number

  /** `total` less `referralCredit` - what the card is actually charged now. */
  @Field(t => Float)
  amountDue!: number

  @Field()
  taxCountryCode!: string

  @Field()
  taxCode!: string

  @Field()
  postalCode!: string

  @Field(t => Int, { nullable: true })
  proratedDate?: number
}
